import { FC } from 'react'
import styled, { css } from 'styled-components'
import DefaultTooltip from '../Tooltips/DefaultTooltip'

export type BadgeSize = 12 | 16

export type WinePackageType = {
  id: number
  isDefault?: boolean
  localizedName: string
  shortName: string
}

interface PackageTypeBadgeProps {
  value?: WinePackageType | null
  size?: BadgeSize
  withTooltip?: boolean
  force?: boolean
}

export const Wrapper = styled.span<{
  $size: BadgeSize
  $defaultCursor?: boolean
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: rgba(113, 114, 132, 0.08);
  cursor: ${props => (props.$defaultCursor ? 'default' : 'pointer')};
  color: var(--grey-2-sw-60, #717284);
  vertical-align: middle;
  margin-bottom: 2px;
  padding: 0 3px;

  ${props =>
    props.$size === 16
      ? css`
          min-width: 18px;
          font: var(--typography-11-16-semibold);
        `
      : css`
          min-width: 14px;
          font: var(--typography-9-12-semibold);
        `};
`

const PackageTypeBadge: FC<PackageTypeBadgeProps> = props => {
  const { value, size = 16, withTooltip = true, force = false } = props

  if (!value) return null
  if (value.isDefault && !force) return null

  if (!withTooltip)
    return (
      <Wrapper $size={size} $defaultCursor>
        {value.shortName}
      </Wrapper>
    )

  return (
    <DefaultTooltip
      placement='top'
      tooltip={value.localizedName}
      component={Wrapper}
      offset={12}
      // @ts-ignore
      $size={size}
    >
      {value.shortName}
    </DefaultTooltip>
  )
}

export default PackageTypeBadge
